import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff, Lock, User, AlertCircle } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: "", password: "" });
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.username || !form.password) { setError("Please enter credentials."); return; }
    setLoading(true); setError("");
    const res = await login(form.username, form.password);
    setLoading(false);
    if (res.success) navigate("/admin/dashboard");
    else setError(res.message || "Invalid credentials");
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-brand-pale via-white to-accent-tealLight flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-3xl shadow-hover p-10 border border-gray-100">
          <div className="text-center mb-8">
            <img src="/logo.png" alt="Sava Fresh" className="h-16 w-auto object-contain mx-auto mb-4" />
            <h1 className="font-heading font-bold text-gray-900 text-xl">Admin Panel</h1>
            <p className="text-gray-400 text-sm mt-1">Sava Fresh Trading FZE</p>
          </div>

          <div className="bg-blue-50 border border-blue-100 rounded-xl p-3 mb-5 text-xs text-blue-700">
            <strong>Demo:</strong> username: <code>admin</code> / password: <code>admin123</code>
          </div>

          {error && (
            <div className="flex items-center gap-2 bg-red-50 border border-red-200 rounded-xl p-3 mb-4 text-red-700 text-sm">
              <AlertCircle className="w-4 h-4 flex-shrink-0" />{error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-semibold text-gray-600 mb-1.5">Username</label>
              <div className="relative">
                <User className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                <input type="text" value={form.username} onChange={e => setForm(f => ({...f,username:e.target.value}))} placeholder="Enter username" className="input-field pl-10" autoComplete="username" />
              </div>
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-600 mb-1.5">Password</label>
              <div className="relative">
                <Lock className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                <input type={showPass ? "text" : "password"} value={form.password} onChange={e => setForm(f => ({...f,password:e.target.value}))} placeholder="Enter password" className="input-field pl-10 pr-10" autoComplete="current-password" />
                <button type="button" onClick={() => setShowPass(!showPass)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700">
                  {showPass ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>
            <button type="submit" disabled={loading} className="btn-primary w-full justify-center py-3.5">
              {loading ? <><div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />Signing in...</> : "Sign In to Admin"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
